export const getDragModifierKeys = (state) => state.getIn(['app', 'dragModifierKeys']);
